import Job, { JOB_STATUS_COMPLETE, JOB_STATUS_IN_PROGRESS } from '@models/job';

const ROLES = {
    ENGINEER: 'engineer',
    BILLING_ADMIN: 'billing_admin',
    JOB_TIME_TRACKING: 'job_time_tracking',
};

const userHasRole = (rootGetters, role) => {
    const userRoles = new Map(rootGetters['AuthenticationStore/mappedRoles']);
    return userRoles.has(role);
};

const userLacksAllRoles = (rootGetters, roles) => roles.every(
    (role) => !userHasRole(rootGetters, role),
);

export default {
    namespaced: true,
    state: {
        job: {},
    },
    getters: {
        isStatic(state, getters, rootState, rootGetters) {
            return state.job.status === JOB_STATUS_COMPLETE
                || userLacksAllRoles(rootGetters, [ROLES.ENGINEER, ROLES.BILLING_ADMIN]);
        },

        canEnterTimeTracking(state, getters, rootState, rootGetters) {
            return state.job.status === JOB_STATUS_IN_PROGRESS
                && userHasRole(rootGetters, ROLES.JOB_TIME_TRACKING);
        },
    },
    mutations: {
        setJob(state, job) {
            state.job = job;
        },
    },
    actions: {
        async getJob({ commit }, jobId) {
            const job = await Job.with('branch', 'customer', 'customerLocation', 'createdByUser').find(jobId);

            commit('setJob', job);
        },
    },
};
